module.exports = __webpack_public_path__ + "static/media/moneypl.e55b91d5.svg";